import React from 'react';
import PropTypes from 'prop-types';
import IconOption from '@components/assignment-filters/filter-options/icon-option/icon-option';

import { FilterOptionsWrapper, FilterOptionsHeading } from './styled';
import { HIGHEST, ASSIGNED, VOLUNTARY } from '../filters-constants';
import getTranslations from '../translations';

const FilterOptions = ({ i18n, filter, handleSelection }) => {
  /**
   * TRANSLATIONS
   */
  const {
    FILTER_TEACHER_ASSIGNED_TEXT,
    FILTER_VOLUNTARY_ATTEMPT_TEXT,
    FILTER_ATTEMPTS_HEADING_TEXT,
    FILTER_ALL_HIGHEST_TEXT,
    FILTER_INFO_HIGHEST_TEXT,
    FILTER_INFO_LATEST_TEXT,
    FILTER_INFO_VOLUNTARY_TEXT
  } = getTranslations({ i18n });

  return (
    <FilterOptionsWrapper>
      <FilterOptionsHeading data-testid="filter-options">{FILTER_ATTEMPTS_HEADING_TEXT}</FilterOptionsHeading>
      <IconOption
        filter={filter}
        handleSelection={handleSelection}
        id={HIGHEST}
        labelText={FILTER_ALL_HIGHEST_TEXT}
        infoText={FILTER_INFO_HIGHEST_TEXT}
      />
      <IconOption
        filter={filter}
        handleSelection={handleSelection}
        id={ASSIGNED}
        labelText={FILTER_TEACHER_ASSIGNED_TEXT}
        infoText={FILTER_INFO_LATEST_TEXT}
      />
      <IconOption
        filter={filter}
        handleSelection={handleSelection}
        id={VOLUNTARY}
        labelText={FILTER_VOLUNTARY_ATTEMPT_TEXT}
        infoText={FILTER_INFO_VOLUNTARY_TEXT}
      />
    </FilterOptionsWrapper>
  );
};

FilterOptions.propTypes = {
  i18n: PropTypes.object.isRequired,
  filter: PropTypes.string.isRequired,
  handleSelection: PropTypes.func.isRequired
};

export default FilterOptions;



// WEBPACK FOOTER //
// ./components/assignment-filters/filter-options/filter-options.js